import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolComponent } from '@app/modules/tools/components/tool/tool.component';
import { SharedModule } from '@app/shared/shared.module';
import { MaterialModule } from '@app/src/material.module';
import { ToolsRoutingModule } from '@app/modules/tools/tools-routing.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddToolComponent } from '@app/modules/tools/components/add-tool/add-tool.component';
import { QualityGatesTableComponent } from '@app/modules/tools/components/quality-gates-cnfg/quality-gates-cnfg.component';

@NgModule({
  imports: [
    CommonModule,
    ToolsRoutingModule,
    MaterialModule,
    SharedModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    ToolComponent,
    QualityGatesTableComponent,
    AddToolComponent,

  ],
  declarations: [ToolComponent, QualityGatesTableComponent, AddToolComponent],

})
export class ToolsModule { }
